import { Link } from 'react-router-dom';

export function HomePage() {
  return (
    <div className="max-w-3xl mx-auto py-12">
      <h1 className="text-2xl font-serif mb-6">Willkommen auf der Patent-Auktionsplattform</h1>

      <p className="mb-4 text-text-secondary leading-relaxed">
        Diese Plattform dient der gezielten Versteigerung technischer Patente an ausgewählte Unternehmen.
        Der Zugang ist ausschließlich per persönlichem Einladungscode möglich.
      </p>

      <p className="mb-4 text-text-secondary leading-relaxed">
        Das Verfahren ist transparent und nachvollziehbar. Unternehmen, die ein Patent erwerben möchten,
        können sich über das offene, anonymisierte Bietverfahren informieren und bei Vorliegen eines
        Einladungscodes registrieren.
      </p>

      <p className="mb-8 text-text-secondary leading-relaxed">
        Interessierte Unternehmen erhalten nach Prüfung einen personalisierten Einladungscode
        und Zugang zu den laufenden und bevorstehenden Auktionen.
      </p>

      <div className="flex gap-4">
        <Link to="/verfahren" className="btn-secondary">Verfahren kennenlernen</Link>
        <Link to="/registrieren" className="btn-primary">Registrieren</Link>
      </div>
    </div>
  );
}
